module.exports = __webpack_public_path__ + "media/images/mbmm-63a9459ab3bd78bac0a7df5daf4dd2cf15271d39002bb9ba1d8f4e73d31c00d6.svg";